import React, { useState } from "react";
import ActivityModule from "@/components/ActivityModule";
import { TrackerTable, PageHeader, Tabs } from "@/components/shared";

const TABS = [
  { id: "activity", label: "Activity & KPIs" },
  { id: "social-posts", label: "Posting Log" },
  { id: "social-growth", label: "Growth Tracker" },
];

export default function SocialMedia() {
  const [active, setActive] = useState("activity");
  return (
    <div>
      <PageHeader title="Social Media Tracker" subtitle="Daily posts → auto KPIs (posts, views, engagement), plus logs" />
      <Tabs tabs={TABS} active={active} onChange={setActive} />
      {active === "activity" ? <ActivityModule module="social" /> : <TrackerTable id={active} />}
    </div>
  );
}
